import { render, staticRenderFns } from "./MegaMenuDropdown.vue?vue&type=template&id=3654f9d9&scoped=true&"
import script from "./MegaMenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./MegaMenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./MegaMenuDropdown.vue?vue&type=style&index=0&id=3654f9d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654f9d9",
  null
  
)

export default component.exports